// extracted by mini-css-extract-plugin
module.exports = {"notes":"notes__2rY8l","row":"row__2Xp4B"};